import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  "ten": undefined, // required - Tên của cấu hình
  "gia_tri": undefined, // required - Giá trị
  "bai_viet_cover_id": undefined, // optional, ref: mushroom_file - Ảnh nền trang bài viết
  "cong_khai": undefined, // required - Cho biết cấu hình này có phải loại công khai hay không
  "thoi_diem_cap_nhat": undefined, // required - Thời điểm cập nhật cuối
  "anh_btn_show": false,
  "anh_url": undefined,
  "anh_show": false,
};


model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_cap_nhat",
  defaultSort: ["thoi_diem_cap_nhat", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      ten: "",
      cong_khai: "",
    },
    valid: {
      ten: [],
      thoi_diem_cap_nhat: []
    },
    operator: {
      ten: ":regex_i:",
      cong_khai: "",
    },
  },
};

export default model;
